// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Tabs_tabs__xFiIJ {
  display: flex;
  justify-content: space-evenly;
  overflow: hidden;
  -ms-overflow-style: none;
  scrollbar-width: none;
}

.Tabs_tabs__xFiIJ::-webkit-scrollbar {
  display: none;
}`, "",{"version":3,"sources":["webpack://./src/components/common/Tabs/Tabs.module.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,6BAAA;EACA,gBAAA;EACA,wBAAA;EACA,qBAAA;AACJ;;AAEA;EACI,aAAA;AACJ","sourcesContent":[".tabs {\n    display: flex;\n    justify-content: space-evenly;\n    overflow: hidden;\n    -ms-overflow-style: none;\n    scrollbar-width: none;\n}\n\n.tabs::-webkit-scrollbar {\n    display: none;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tabs": `Tabs_tabs__xFiIJ`
};
export default ___CSS_LOADER_EXPORT___;
